import { useMemo } from 'react';
import { useStore } from 'react-redux';

import { Organisation } from '@futrli-sdk/organisations';
import { WorkspacesListingItem } from '@futrli-sdk/workspaces';
import { getTransformedOrgData, isPending, workspaceByIdSelector } from '@futrli/shared-services';
import { useIntegrationsView } from '@futrli/views/hooks/useIntegrationsView';

import { StoreState } from '../../core/types';

export const useWorkspaceOrganisations = (workspaceId: string) => {
  const state = useStore<StoreState>().getState();
  const { normalised } = state;
  const { integrations, isLoading: integrationsLoading } = useIntegrationsView(false);
  const isDataLoading =
    isPending(state.loadingRequests.FETCH_FROM_REMOTE_GET_ORGANISATIONS) ||
    isPending(state.loadingRequests.FETCH_FROM_REMOTE_GET_WORKSPACE_PERMISSIONS) ||
    integrationsLoading;

  const storedIntegrations = useMemo(() => integrations || [], [integrations]);
  const storedWorkspace = workspaceByIdSelector(normalised, workspaceId);

  let storedOrganisations: Organisation[] | null = [];
  const workspaceOrgs = (storedWorkspace as WorkspacesListingItem)?.organisations;
  storedOrganisations = useMemo(
    () => workspaceOrgs?.map(o => getTransformedOrgData(o, workspaceId, storedIntegrations)),
    [storedIntegrations, workspaceId, workspaceOrgs]
  );

  return {
    isDataLoading,
    workspace: storedWorkspace,
    integrations: storedIntegrations,
    organisations: storedOrganisations
  };
};
